/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Para3Inputs */

const zh_landing_audience_para3 = /** @type {(inputs: Landing_Audience_Para3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把它当作你的 AI 教学助手——永远在线，从不疲倦。`)
};

const en_landing_audience_para3 = /** @type {(inputs: Landing_Audience_Para3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Think of it as your AI teaching assistant — always ready, never tired.`)
};

const es_landing_audience_para3 = /** @type {(inputs: Landing_Audience_Para3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Considéralo tu asistente de enseñanza con IA: siempre disponible, nunca cansado.`)
};

/**
* | output |
* | --- |
* | "Think of it as your AI teaching assistant — always ready, never tired." |
*
* @param {Landing_Audience_Para3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_para3 = /** @type {((inputs?: Landing_Audience_Para3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Para3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_para3(inputs)
	if (locale === "en") return en_landing_audience_para3(inputs)
	return es_landing_audience_para3(inputs)
});